<template>
  <div id="contenedor-planeacion-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <v-tab
          v-if="!opcion.hidden"
          :key="index"
          :to="{ name: opcion.ruta }"
          exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'PlaneacionOpcinesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Firmas',
          ruta: 'planeacionConfiguracionFirmas',
          icono: '',
        },
        {
          nombre: 'Plantillas',
          ruta: 'planeacionConfiguracionPlantillas',
          icono: '',
        },
        {
          nombre: 'Etiquetas',
          ruta: 'planeacionConfiguracionEtiquetas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
